var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-select-grantee"},[_c('v-alert',{staticClass:"alert-alert",attrs:{"dark":"","type":"info","max-width":parseInt(_vm.maxWidth),"color":"#5a5a5a"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }